import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const RequestLink = () => {
  const texts = TextBundle({ id: "help-center" })

  return (
    <div className="w-auto min-w-[310px] max-w-fit md:h-[68px] flex flex-col md:flex-row flex-none justify-center items-center bg-primary/5 border border-primary/10 rounded-[40px] gap-2 px-5 py-5 md:py-0 mx-auto">
      <Typography variant="body1" className="my-0">
        {texts?.request_link_text || "Don't find what you're looking for?"}
      </Typography>
      <Typography variant="body1" className="my-0">
        <a href="/help-center/submit-request" className="text-primary underline font-bold">
          {texts?.request_link_cta || "Submit a request"}
        </a>
      </Typography>
    </div>
  )
}

export default RequestLink
